import EPReferralForm from '../components/EPReferralForm'
import PDF from '../assets/files/ep-referral-form.pdf'

const EPReferral = () => {
  return (
    <>
      {/* Page Header */}
      <div className="flex w-dvw bg-lightblue bg-[url(./assets/images/bubblebg.webp)] py-12">
        <div className="pb-6 text-center font-display text-6xl leading-18 text-blue sm:pb-0 mx-auto">
          Exercise Physiology Referral Form
        </div>
      </div>
      <div className="mx-auto w-fit max-w-3xl px-6 pt-12">
        <p>
          To access our Exercise Physiology services, please complete the form below. If you would prefer a PDF version of this form,{" "}
          <a href={PDF} target="_blank" className="text-link">
            click here
          </a>
          .
        </p>
      </div>
      <EPReferralForm />
    </>
  )
}

export default EPReferral